/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Form, Button } from "react-bootstrap";
import { filterInitialState } from "../../Quizzes/quizInitialStates";
import { buildQueryStr } from '../../../helpers/utils';

//components
import EditorQuestionsTable from '../editor-questions-table/editor-questions-table.component';
import DeleteEditGroup from '../../ui/delete-edit-group/delete-edit-group.component';
import DeleteModal from '../../ui/delete-modal/delete-modal.component';
import Layout from '../../ui/layout/layout.component';
import Footer from '../../Common/footer/footer.component';
import { useHistory } from "react-router-dom";

// selectors
import { selectAllQuestions } from '../../../redux/question/question.select';
import { selectAllQuestionsCount } from '../../../redux/question/question.select';
import { selectDeletingQuestion } from './../../../redux/question/question.select';
import { selectStandardCode } from './../../../redux/question/question.select';

//actions
import questionActions from '../../../redux/question/question.action';
import './all-questions.component.styles.css';

const AllQuestions = () => {
	const dispatch = useDispatch(); 
	const history = useHistory();

	//pagination
	const [currentPage, setCurrentPage] = useState(1);
	const [questionsPerPage] = useState(90);

	const [filters, setFilters] = useState(filterInitialState);
	const [isSearching, setIsSearching] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState({
		showModal: false,
	});

	let questions = useSelector(selectAllQuestions);
	const questionsCount = useSelector(selectAllQuestionsCount);
	const deletingQuestion = useSelector(selectDeletingQuestion);

	const standardCodeData = useSelector(selectStandardCode);

	const gradeCodeField = standardCodeData &&
	standardCodeData
		.reduce((unique, item) => {
			const uf = unique.filter((ui) => ui.standard_set === item.standard_set);
			return uf.length && uf[0].grade === item.grade ? unique : [...unique, item]
		}, [])

	useEffect(() => {
		fetchQuestions(currentPage, filters, isSearching);
	}, [currentPage, isSearching]);

  const totalPages = Math.ceil(questionsCount / questionsPerPage);
  const pageRanges = Array.from({ length: totalPages }, (_, i) => {
    const start = i * questionsPerPage + 1;
    const end = Math.min((i + 1) * questionsPerPage, questionsCount);
    return { label: `${start} - ${end}`, page: i + 1 };
  });


	const handleOpen = (id) => {
		setShowDeleteModal({ ...showDeleteModal, showModal: true, id });
	};

	const handleClose = () => {
		setShowDeleteModal(false);
	};

const handleDelete = (id) => {
  dispatch(questionActions.deleteQuestion(id)).then((data) => {
    if (data?.status_code) {
      handleClose();
      return;
    }

    if (questions.length === 1 && currentPage > 1) {
      setCurrentPage((p) => p - 1);
    } else {
      fetchQuestions(currentPage, filters, isSearching);
    }

    handleClose();
  });
};


	const handleEditForm = (data) => {
		dispatch(questionActions.getSingleQuestion(data.id));
		dispatch(questionActions.getAnswer(data.id));
		history.push("/create-question");
	};

	const renderDeleteEdit = (id, data) => {
		return (
			<DeleteEditGroup
				handleShow={handleOpen}
				handleEditForm={handleEditForm}
				handleShowParam={id}
				handleEditFormParam={data}
			/>
		);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
	};

	const handleSearch = () => {
		setIsSearching(true);
		setCurrentPage(1);
		fetchQuestions(1, filters, true);
	};

	const handleClearSettings = () => {
		setFilters(filterInitialState);
		setIsSearching(false);
		setCurrentPage(1);
		fetchQuestions(1, filterInitialState, false);
	};

	const fetchQuestions = (page = currentPage, appliedFilters = filters, searching = isSearching) => {
		const baseQuery = `limit=${questionsPerPage}&offset=${(page - 1) * questionsPerPage}&ordering=id`;
		const query = searching ? `${baseQuery}${buildQueryStr(appliedFilters)}` : baseQuery;

		dispatch(questionActions.getAllQuestions(query));
	};

	useEffect(() => {
		dispatch(questionActions.getStandardCode());
	}, []);

	return (
		<>
		<Container>
			<Layout>
				<h5>Search Questions</h5>
				<div className='question-form'>
					<Form.Group className="d-flex flex-column align-items-center" style={{width: "250px"}}>
						<Form.Label className="question-label">Grades</Form.Label>
	
						<Form.Control
							as="select"
							value={filters.grade_level}
							onChange={handleChange}
							name="grade_level"
						>
							<option value="_Any">{"_Any".slice(1)}</option>
	
							{gradeCodeField && gradeCodeField.map((grade) => (
								<option key={grade.grade}>{grade.grade}</option>
							))}
						</Form.Control>
					</Form.Group>
					<Form.Group className="d-flex flex-column align-items-center" style={{width: "250px"}}>
						<Form.Label className="question-label">ID</Form.Label>
						<Form.Control
							value={filters.id}
							onChange={handleChange}
							name="id"
						></Form.Control>
					</Form.Group>
					<Form.Group className="d-flex flex-column align-items-center" style={{width: "250px"}}>
						<Form.Label className="question-label">Content Source</Form.Label>
						<Form.Control
							value={filters.content_source}
							onChange={handleChange}
							name="content_source"
						></Form.Control>
					</Form.Group>
					<Form.Group className="d-flex flex-column align-items-center" style={{width: "250px"}}>
						<Form.Label className="question-label">Question Style</Form.Label>
						<Form.Control
							as="select"
							value={filters.question_style}
							onChange={handleChange}
							name="question_style"
						>
							<option value="_Any">{"_Any".slice(1)}</option>
							<option>Numeric</option>
							<option>Word</option>
							<option>Graphic</option>
						</Form.Control>
					</Form.Group>
				</div>
				<div className='justify-content-center submit-buttons-container'>
					<Form.Group
						// as={Col}
						className="d-flex flex"
						md={2}
					>
						<Button
							className="btn btn-custom btn-secondary-custom"
							onClick={handleClearSettings}
						>
							Clear Settings
						</Button>
					</Form.Group>
					<Form.Group
						// as={Col}
						className="d-flex flex"
						md={2}
					>
						<Button
							className="btn btn-custom btn-secondary-custom"
							onClick={handleSearch}
						>
							{/* {loadingUserQuestions === true && (
								<span className="spinner-border spinner-border-sm mr-1"></span>
							)} */}
							Search
						</Button>
					</Form.Group>
				</div>
				<hr/>
				<div className="pagination-container">
					{pageRanges.map(({ label, page }) => (
						<button
							key={page}
							onClick={() => setCurrentPage(page)}
							style={{
								backgroundColor: page === currentPage ? '#007BFF' : 'transparent',
								color: page === currentPage ? '#fff' : '#000',
							}}
						>
							{label}
						</button>
					))}
				</div>
				<EditorQuestionsTable questions={questions} all={true} renderDeleteEdit={renderDeleteEdit} />
				<DeleteModal
					id={showDeleteModal.id}
					showModal={showDeleteModal.showModal}
					deleting={deletingQuestion}
					handleClose={handleClose}
					handleDelete={handleDelete}
					message="Question will be deleted"
					messageId="questionDeleteMessage"
				/>
			</Layout>
			<Footer/>
			</Container>
		</>
	);
};

export default AllQuestions;
